module.exports = __webpack_public_path__ + "media/packs/images/flags/CU-91af15fd1a741ab96fa7f5466adae617.png";